import MeasureChart from './MeasureChart';

export default MeasureChart;
